import { Select, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledSelect = styled(Select)(({ theme }) => ({
  height: '48px',
  display: 'flex',
  borderRadius: '8px',
  color: theme.custom?.text || '#03252E',
  backgroundColor: theme.custom?.background2 || '#F5F5F5',
  '&:hover': {
    cursor: 'pointer',
  },
  '& fieldset': {
    borderRadius: '8px',
    border: '0',
  },
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: `${theme.custom?.background2 || '#F5F5F5'} !important`,
  },
  '&.Mui-focused': {
    backgroundColor: theme.custom?.background2 || '#F5F5F5',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: '0',
  },
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  width: '100%',
  height: '48px',
  padding: '12px 16px',
  margin: 0,
  backgroundColor: theme.custom?.background1 || 'white',
  borderBottom: `1px solid ${theme.custom?.stroke || '#D0D2D8'}`,
  display: 'flex',
  color: theme.custom?.text || 'black',
  alignItems: 'center',
  borderRadius: 0,
  '&.Mui-selected': {
    backgroundColor: theme.custom?.primaryLight || '#FAC8B2',
    color: '#03252E',
    opacity: 1,
    '&:hover': {
      backgroundColor: theme.custom?.primaryLight || '#FAC8B2',
      color: '#03252E',
    },
  },
  '&:hover': {
    backgroundColor: theme.custom?.primaryLight || '#FAC8B2',
    color: '#03252E',
    cursor: 'pointer',
  },
  '&:first-of-type': {
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
  },
  '&:last-of-type': {
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
  },
}));
